import { render, staticRenderFns } from "./AppCard.vue?vue&type=template&id=06b1c58a&scoped=true&"
import script from "./AppCard.vue?vue&type=script&lang=js&"
export * from "./AppCard.vue?vue&type=script&lang=js&"
import style0 from "./AppCard.vue?vue&type=style&index=0&id=06b1c58a&lang=scss&scoped=true&"
import style1 from "./AppCard.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06b1c58a",
  null
  
)

export default component.exports